import { render, staticRenderFns } from "./funFooter.vue?vue&type=template&id=3ef242e5&scoped=true"
import script from "./funFooter.vue?vue&type=script&lang=js"
export * from "./funFooter.vue?vue&type=script&lang=js"
import style0 from "./funFooter.vue?vue&type=style&index=0&id=3ef242e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef242e5",
  null
  
)

export default component.exports